import { Button, Card, Col, Form, Row, Select, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
// import { SectionCard } from "../AddTreasuryBill";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import React from "react";
import { Util } from "../helper/helper";
import SectionCard from "./SectionCard";

const { Text, Link, Title, Paragraph } = Typography;

export default function Accounting({ setData, data, setActivePage, activePage, template, setHasModified, hasModifed }) {
  const [form] = Form.useForm();
  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }

  function goBack() {
    setActivePage(activePage - 1);
  }
  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }
  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  const symbol = Util.getCurrencyCode(template, data);
  const filteredAssetGL = template?.assetGLAccounts.filter((item, i) => item?.currencyCode === symbol);
  const filteredIncomeGL = template?.incomeGLAccounts.filter((item, i) => item?.currencyCode === symbol);

  console.log(filteredAssetGL, filteredIncomeGL);

  return (
    <SectionCard nextTitle={"Next - Preview"} onNext={form.submit} onPrev={goBack}>
      <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
        Accounting
      </Title>

      <Form className="custom-form" layout="vertical" onFinish={onFinish} form={form} onValuesChange={handleValuesChange} style={{ marginY: 30, marginTop: 30 }}>
        <Row
          style={{
            background: "#F9FAFB",
            padding: "12px 24px",
            borderRadius: "8px 8px 0 0",
            marginBottom: "8px",
          }}
        >
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Events</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Debit GL</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Credit GL</span>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Investment - Deal Booking
            </span>
          </Col>
          <Col span={8}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="investmentDealBookingDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="investmentDealBookingCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Interest Accrual Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="interestAccrualDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="interestAccrualCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Investment - Redemption (Customer Payable)
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="investmentRedemptionDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="investmentRedemptionCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredAssetGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>

        {/* ---- */}
        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Interest Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomeInterestDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomeInterestCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Fees Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomeFeesDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomeFeesCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Penalty Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomePenaltyDebit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
              name="incomePenaltyCredit"
            >
              <Select className="custom-input" placeholder="Select GL Account" options={filteredIncomeGL} style={{ width: "90%", height: "44px" }} suffixIcon={<ChevronDown color="#667085" width={20} />} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SectionCard>
  );
}
